import { requestWithToken as request } from "./api";

export const createBookRemuneration = (data = {}) =>
    request.post("/s3_book_remunerations/", data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

export const checkStatusValidation = (kind_file) =>
    request.get(
        `/s3_book_remunerations/validate_status/?kind_file=${kind_file}&format=json`
    );
